import DataExportDataSetDropdownBase from './DataExportDataSetDropdownBase'

export default function MasterDataTypeDropdown({value, onChange}){
    const options = ['List of all Locations',
        'List of all Contacts',
        'List of all Services',
        'List of all Clients'];

    return(
        <DataExportDataSetDropdownBase options={options} value={value} onChange={onChange} />
    );
}